import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormInput } from '../input/FormInput'

interface IDropDownProps {
  oldName: string
  setShowRenameDeviceModal: (show: boolean) => void
  renameUserDevice: (newName: string) => void
}

type renameDeviceInput = {
  name: string
}

const renameDeviceSchema = yup.object().shape({
  name: yup.string().required('Device name is required'),
})

function DeviceRenameModal(props: IDropDownProps) {
  const { oldName, setShowRenameDeviceModal, renameUserDevice } = props
  const [newName, setNewName] = useState<string>(oldName)

  const {
    register,
    handleSubmit,
    formState: { isValid },
    reset,
  } = useForm<renameDeviceInput>({
    resolver: yupResolver(renameDeviceSchema),
    mode: 'onChange',
    defaultValues: { name: oldName },
  })

  const onSubmit: SubmitHandler<renameDeviceInput> = async (device) => {
    setNewName(device.name)
    await renameUserDevice(device.name)
    reset()
  }

  return (
    <div
      className="bg-black bg-opacity-50 absolute top-0 left-0 w-full h-full z-50"
      onClick={() => setShowRenameDeviceModal(false)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[50%] overflow-y-auto border dark:border-gray-600"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-xl font-bold mb-4">Rename Device</h2>
          <p className="mb-4">Device name will be updated everywhere in portal</p>
          <FormInput
            value={newName}
            type="text"
            {...register('name', { required: true })}
            placeholder="Enter a device name"
            maxLength={120}
          />

          <div className="flex justify-end mt-6">
            <button
              className="px-4 py-2 mr-2 bg-gray-300 rounded-lg text-neutral-12"
              onClick={() => setShowRenameDeviceModal(false)}
              type="button"
            >
              Cancel
            </button>
            <button
              className={`px-4 py-2 bg-mainPurple text-white rounded-lg ${!isValid ? 'disabled opacity-50 cursor-not-allowed' : 'hover:bg-tertiaryPurple active:active:bg-tertiaryPurple'}`}
              type="submit"
              disabled={!isValid}
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default DeviceRenameModal
